var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "keep-alive",
    [
      _c(_vm.sideType, {
        tag: "component",
        staticClass: "content",
        style: { display: _vm.isSearchOpened ? "none" : "flex" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }